import { TypedUseSelectorHook, useDispatch as useReduxDispatch, useSelector } from 'react-redux';

import { Dispatch, RootState } from './store';

export const useRematch: TypedUseSelectorHook<RootState> = useSelector;
export const useDispatch: () => Dispatch = useReduxDispatch;
